__turbopack_context__.v({
  "active": "BurgerMenu-module__MG2ABG__active",
  "bottom": "BurgerMenu-module__MG2ABG__bottom",
  "burger-button": "BurgerMenu-module__MG2ABG__burger-button",
  "line": "BurgerMenu-module__MG2ABG__line",
  "menu": "BurgerMenu-module__MG2ABG__menu",
  "nav-link": "BurgerMenu-module__MG2ABG__nav-link",
  "nav-links": "BurgerMenu-module__MG2ABG__nav-links",
  "overlay": "BurgerMenu-module__MG2ABG__overlay",
  "top": "BurgerMenu-module__MG2ABG__top",
});
